import React from 'react'
import * as UI from '@brewlogix/blx-ui'
import classNames from 'classnames'
import { stateOptions } from '../../utils/constants'
import { useFilterStore } from 'src/features/brewknowledge/state/filterStore'
interface IStateOption {
    label: string
    value: string
}

const State: React.FC = () => {
    const {
        toggleStateArrowUp,
        setToggleStateArrowUp,
        setStateFilter,
        setPage,
        setNextResultsOffset,
    } = useFilterStore()
    const stateOptionSelections = [
        ...stateOptions.map((option) => {
            return {
                label: option,
                value: option,
            }
        }),
    ]
    const handleStateSelection = (e: IStateOption) => {
        setPage(1)
        setNextResultsOffset(null)
        setStateFilter(e?.value)
    }
    return (
        <div
            className={classNames(
                'flex w-full flex-col items-start justify-start',
                toggleStateArrowUp ? 'mb-6' : ''
            )}
        >
            <UI.Button
                label='State'
                data-cy='filterState'
                theme='link'
                customClasses='flex flex-row-reverse justify-start text-dark pb-0 pl-0 mb-4'
                onClick={() => setToggleStateArrowUp(!toggleStateArrowUp)}
                size='sm'
            >
                <UI.Icon
                    slug='HeroIcons.ChevronRight'
                    size='sm'
                    customClasses={classNames(
                        toggleStateArrowUp ? '-rotate-90' : '',
                        'text-gray-300 mr-2 pointer-events-none'
                    )}
                />
            </UI.Button>

            <div
                className={classNames(
                    !toggleStateArrowUp ? 'hidden' : '',
                    'flex w-full flex-col pl-1'
                )}
            >
                <UI.DynamicSelect
                    id='brewStates'
                    label=''
                    placeholder='Select a state'
                    size='sm'
                    isLoading={!stateOptions || stateOptions.length < 1}
                    isClearable={true}
                    isSearchable={true}
                    onChange={(e) => handleStateSelection(e)}
                    options={stateOptionSelections}
                    aria-label='Select a state'
                    instanceId='brewStates'
                />
            </div>
        </div>
    )
}

export default State
